module.exports = __webpack_public_path__ + "img/Lobby_Video.19169e20.png";